// Chakra imports
import { AvatarGroup, Avatar, Box, Button, Flex, Icon, Image, Link, Text, useColorModeValue } from '@chakra-ui/react';
import { apiurl } from 'APIURL';
import axios from 'axios';
// Custom components
import Card from 'components/card/Card';
import React from 'react';
// Assets
import { useState } from 'react';
import { IoHeart, IoHeartOutline } from 'react-icons/io5';
import { Profile } from 'types';

export default function NFT(props: {
	id:number,
	image: string;
	name: string;
	numOfCandidates:number,
	author: string;
	bidders: string[];
	download: string;
	currentbid: string | number;
	onSubscribe:React.MouseEventHandler<HTMLButtonElement>,
	subscribed?:boolean,

}) {
	const { image, name, author, bidders, download, currentbid,onSubscribe,numOfCandidates,id,subscribed } = props;
	const [ like, setLike ] = useState(false);
	const [showMore,setShowMore] = useState(true)
	const [ sub, setSubscribed ] = useState(subscribed);
	const textColor = useColorModeValue('navy.700', 'white');
	const [candidates,setCandidates] =useState<Profile[]>([])
	const textColorBid = useColorModeValue('brand.500', 'white');

	React.useEffect(
		()=>{
			const getCandidates= async (formationId:number)=>{
				const res = await axios.get(`${apiurl}/formation/candidates/${formationId}`)
		
				setCandidates(res.data)
			}
			getCandidates(id)
		},[id]
	)
	return (
		<Card p='20px'>
			<Flex direction={{ base: 'column' }} justify='center'>
				<Box mb={{ base: '20px', '2xl': '20px' }} position='relative'>
					<Image
						src={image}
						w={{ base: '100%', '3xl': '100%' }}
						h={{ base: '100%', '3xl': '100%' }}
						borderRadius='20px'
					/>
					<Button
						position='absolute'
						bg='white'
						_hover={{ bg: 'whiteAlpha.900' }}
						_active={{ bg: 'white' }}
						_focus={{ bg: 'white' }}
						p='0px !important'
						top='14px'
						right='14px'
						borderRadius='50%'
						minW='36px'
						h='36px'
						onClick={() => {
							setLike(!like);
						}}>
						<Icon
							transition='0.2s linear'
							w='20px'
							h='20px'
							as={like ? IoHeart : IoHeartOutline}
							color='brand.500'
						/>
					</Button>
				</Box>
				<Flex flexDirection='column' justify='space-between' h='100%'>
					<Flex
						justify='space-between'
						direction={{
							base: 'row',
							md: 'column',
							lg: 'row',
							xl: 'column',
							'2xl': 'row'
						}}
						mb='auto'>
						<Flex direction='column'>
							<Text
								color={textColor}
								fontSize={{
									base: 'xl',
									md: 'lg',
									lg: 'lg',
									xl: 'lg',
									'2xl': 'md',
									'3xl': 'lg'
								}}
								mb='5px'
								fontWeight='bold'
								me='14px'>
								{name}
							</Text>
							<Text
								color='secondaryGray.600'
								fontSize={{
									base: 'sm'
								}}
								fontWeight='400'
								me='14px'>
								{(author.length>50 && showMore===true)?author.slice(0,80):author} <Text
								
								color='brand.500'
								fontSize={{
									base: 'sm'
								}}
								fontWeight='400'
								me='14px' cursor={"pointer"} onClick={()=>setShowMore(!showMore)}>{showMore===true?"Lire la suite...":"Réduire"}</Text>
							</Text>
						</Flex>
						<AvatarGroup
							max={3}
							color={textColorBid}
							size='sm'
							mt={{
								base: '0px',
								md: '10px',
								lg: '0px',
								xl: '10px',
								'2xl': '0px'
							}}
							fontSize='12px'>
							{candidates && candidates.map((avt, key) => <Avatar key={key} src={avt.image} />)}
						</AvatarGroup>
					</Flex>
					<Flex
						align={{
							base: 'center',
							md: 'start',
							lg: 'center',
							xl: 'start',
							'2xl': 'center'
						}}
						justify='space-between'
						direction={{
							base: 'row',
							md: 'column',
							lg: 'row',
							xl: 'column',
							'2xl': 'row'
						}}
						mt='25px'>
						<Text fontWeight='700' fontSize='sm' color={textColorBid}>
							Prix: {currentbid}
						</Text>
						<Text fontWeight='700' fontSize='sm' color={textColorBid}>
							Nombre des candidats: {candidates.length}
						</Text>
						<Link
							href={download}
							mt={{
								base: '0px',
								md: '10px',
								lg: '0px',
								xl: '10px',
								'2xl': '0px'
							}}>
							<Button
							onClick={e=>{onSubscribe(e)
							setSubscribed(!subscribed)
							}}
								variant='darkBrand'
								color='white'
								fontSize='sm'
								fontWeight='500'
								borderRadius='70px'
								px='24px'
								py='5px'>
								{subscribed===false?"Inscrire":"Visiter"}
							</Button>
						</Link>
					</Flex>
				</Flex>
			</Flex>
		</Card>
	);
}
